import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@inkline/inkline/dist/inkline.css'
import Inkline from '@inkline/inkline'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBriefcase, faMapMarkedAlt, faEnvelope, faUserTie, faAt, faArrowRight, faMobile } from '@fortawesome/free-solid-svg-icons'
import { faCopyright } from '@fortawesome/fontawesome-free-regular'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueI18n from 'vue-i18n'
import 'swiper/dist/css/swiper.css'
import text from './locales'
import FlagIcon from 'vue-flag-icon'

library.add(faBriefcase, faMapMarkedAlt, faEnvelope, faUserTie, faAt, faLinkedin, faArrowRight, faCopyright, faMobile)

const VueScrollTo = require('vue-scrollto')

Vue.use(Inkline)
Vue.use(VueScrollTo)
Vue.use(VueAwesomeSwiper)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueI18n)
Vue.use(FlagIcon)

Vue.config.productionTip = false

const userLang = navigator.language;
let locale = 'en'
if (userLang === 'sk' || userLang === 'cs') {
  locale = 'sk'
}

const i18n = new VueI18n({
  locale: locale,
  messages: text,
})

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

window.addEventListener('scroll', function () {
  let navbar = document.getElementById('navbar')
  this.scrollY > 10 ? navbar.classList.add('shown') : navbar.classList.remove('shown')
  let logo = document.getElementById('navbar-logo')
  this.scrollY > 450 ? logo.classList.add('fade') : logo.classList.remove('fade')
}, false)

window.onload = function () {
  let navbar = document.getElementById('navbar')
  navbar.onclick = () => {
    if (!navbar.classList.contains('shown')) {
      navbar.classList.add('shown')
    }
  }

  let modalHeader = document.getElementById('modal-header-div').parentElement
  modalHeader.firstChild.innerHTML = ''
  let modalHeaderStyle = modalHeader.style
  modalHeaderStyle.backgroundColor = 'white'
  modalHeaderStyle.paddingBottom = '0'
  modalHeaderStyle.borderBottom = 'none'

  let modalBodyStyle = document.getElementById('modal-inside-div').parentElement.style
  modalBodyStyle.borderBottomLeftRadius = '.25rem'
  modalBodyStyle.borderBottomRightRadius = '.25rem'
  modalBodyStyle.paddingTop = '0'
  modalBodyStyle.textAlign = 'center'

  if (/Mobi|Android/i.test(navigator.userAgent)) {
    let backgrounds = document.getElementsByClassName('card-header-img')

    for (let i in backgrounds) {
      // eslint-disable-next-line no-unused-vars
      let background = backgrounds[i]
      // background.style.backgroundAttachement = 'scroll'
      // background.style.size = '200px 200px'
    }
  }
}
